/**
 * Lowercases and folds accents for case- and accent-insensitive substring matching.
 */

export function normalizeWordText(text: string): string {
  return text.toLowerCase().normalize('NFD').replace(/\p{M}/gu, '');
}
